import Swiper from 'swiper/bundle'


(function($) {
    
    $.fn.isInViewport = function () {
        let elementTop = $(this).offset().top;
        let elementBottom = elementTop + $(this).outerHeight();
    
        let viewportTop = $(window).scrollTop();
        let viewportBottom = viewportTop + $(window).height();
        return elementBottom > viewportTop && elementTop < viewportBottom;
    };

    $.fn.exist = function(){
        return $(this).length > 0;
    }

    $(".navbar-toggler").click(function(){

        var nav = $(".menu-wrapper");
        if($(nav).hasClass("active")){
            $(nav).removeClass("active");
            $(".navbar-toggler .mdi-close").addClass("d-none");
            $(".navbar-toggler .mdi-menu").removeClass("d-none");
        }else{
            $(nav).addClass("active");
            $(".navbar-toggler .mdi-close").removeClass("d-none");
            $(".navbar-toggler .mdi-menu").addClass("d-none");
        }
        // $(".navbar-toggler i:first-child()").toggleClass("");
    });

    

    if($(window).width() > 1024){
        $('.menu-wrapper [data-toggle="dropdown"], .menu-wrapper .dropdown-menu').on('mouseenter', function(e){
            $(this).next().addClass('show');
        });

        $('li.dropdown').on('mouseleave', function(e){
            $(".menu-wrapper .dropdown-menu").removeClass('show');
        });
    }



    if($(".auto-h").length > 0){

        function igualate(){
            setTimeout(() => {
                $(".auto-h").each(function(i, wrapper){
                    $(wrapper).find(".auto-h-item").css("height", "auto"); //reset
                    var maxHeight = 0;
    
                    $(wrapper).find(".auto-h-item").each(function(x, item){
                        if($(item).outerHeight() > maxHeight) {
                            maxHeight = $(item).outerHeight();
                        }
                    });
                    $(wrapper).find(".auto-h-item").css("height", maxHeight);
                });
            }, 300);
        }
        if($(window).width() > 700){
            igualate();
        }

        $(window).on('resize', igualate);
    }


    if($(".policies-swiper").length > 0){
        new Swiper(".policies-swiper", {
            slidesPerView: 1,
            spaceBetween: 30,
            pagination: {
                el: ".policies-pagination",
                clickable: true,
            },
            breakpoints: {
                375: {
                    slidesPerView: 1,
                    spaceBetween: 30,
                },
                768: {
                    slidesPerView: 2,
                    spaceBetween: 30
                },
                1024: {
                    slidesPerView: 3,
                    spaceBetween: 30
                },
                1440: {
                    slidesPerView: 3,
                    spaceBetween: 30,
                }
            },
        });
    }


    if($(".news-swiper").length > 0){
        new Swiper(".news-swiper", {
            slidesPerView: 1,
            spaceBetween: 30,
            loop: true,
            autoplay: {
                delay: 8000,
                disableOnInteraction: true,
            },
            pagination: {
                el: ".news-pagination",
                clickable: true,
            },
        });
    }
    


    $(document).on('wpcf7mailsent', function(){
        var redirectionEl = $('[data-redirection]');
        

        if(redirectionEl.length > 0){
            window.location = $(redirectionEl).data('redirection');
        }
    });

    document.addEventListener('DOMContentLoaded', () => {
        // document.addEventListener('change', e => {
        //     if (e.target.closest('.wpcf7')) e.stopImmediatePropagation();
        // }, true);

        // document.addEventListener('input', e => {
        //     if (e.target.closest('.wpcf7')) e.stopImmediatePropagation();
        // }, true);
    });


})( jQuery );